import elementService from "@/common/ElementService";

export default new class EmptyCategoryProductListService {
    private static readonly SoldProductScrollStep = 230;

    public init(): void {
        this.initSoldSliders();
    }

    private initSoldSliders(): void {
        const soldSliderContainer = document.querySelector<HTMLDivElement>(".js-sold-slider-container");

        if (soldSliderContainer === null) {
            return;
        }

        const soldSliderProducts = elementService.elementQuerySelector<HTMLDivElement>(soldSliderContainer, ".js-sold-slider-products");
        const slideLeftButton = elementService.elementQuerySelector<HTMLDivElement>(soldSliderContainer, ".js-slide-left");
        const slideRightButton = elementService.elementQuerySelector<HTMLDivElement>(soldSliderContainer, ".js-slide-right");

        slideLeftButton.addEventListener("click", () => this.scrollSoldProductsToLeft(soldSliderProducts));
        slideRightButton.addEventListener("click", () => this.scrollSoldProductsToRight(soldSliderProducts));
    }

    private scrollSoldProductsToLeft(soldSliderProducts: HTMLDivElement): void {
        this.scrollSoldProductsByStep(soldSliderProducts, -1 * EmptyCategoryProductListService.SoldProductScrollStep);
    }

    private scrollSoldProductsToRight(soldSliderProducts: HTMLDivElement): void {
        this.scrollSoldProductsByStep(soldSliderProducts, EmptyCategoryProductListService.SoldProductScrollStep);
    }

    private scrollSoldProductsByStep(soldSliderProducts: HTMLDivElement, step: number): void {
        const start = soldSliderProducts.scrollLeft;
        const end = start + step;
        const duration = 400;
        const startTime = performance.now();

        const animate = (currentTime: number): void => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            soldSliderProducts.scrollLeft = start + ((end - start) * progress);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }
}();
